import { format } from 'date-fns'

import { EMPTY_OBJECT } from '../../constants/common'
import { DATE_FULL_FORMAT_FROM_TIME } from '../../constants/date'
import { toUkTimezoneDate } from '../../utils/date'
import { getUserId, isDwellerRole } from '../../utils/user'

import {
  NEWSBOARD_REQUEST_FEEDBACK_TYPE,
  NEWSBOARD_REQUEST_STATUS_CHANGED_TYPE,
  NEWSBOARD_SYSTEM_TYPE,
  NEWSBOARD_TICKER_TYPE,
  NEWSBOARD_WELCOME_CUSTOM_POST_TYPE,
} from './Newsboard.constants'

// Dwellers should only see owner-restricted post details (post age, status)
// on their own posts; staff can always view them. While the viewer is still
// loading, hide the fields rather than assume access.
export function isNewsboardPostOwnerRestrictedFieldVisible(postData, user) {
  if (!user) {
    return false
  }

  if (!isDwellerRole(user)) {
    return true
  }

  return getUserId(user) === postData?.created_by
}

export function getNewsboardPostTimeRange(data, timezone) {
  const { date_from: dateFrom, date_to: dateTo } = data || EMPTY_OBJECT

  if (!dateFrom && !dateTo) {
    return null
  }

  const from = dateFrom
    ? format(toUkTimezoneDate(dateFrom, timezone), DATE_FULL_FORMAT_FROM_TIME)
    : null
  const to = dateTo
    ? format(toUkTimezoneDate(dateTo, timezone), DATE_FULL_FORMAT_FROM_TIME)
    : null

  if (from && to) {
    return `${from} — ${to}`
  }

  return from || to
}

export function isRequestPostType(data) {
  return data?.post_type?.title === NEWSBOARD_REQUEST_STATUS_CHANGED_TYPE
}

export function isRequestFeedbackType(data) {
  return data?.post_type?.title === NEWSBOARD_REQUEST_FEEDBACK_TYPE
}

export function isTvTickerPostType(data) {
  return (
    data?.post_type === NEWSBOARD_TICKER_TYPE ||
    data?.post_type?.title === NEWSBOARD_TICKER_TYPE
  )
}

export function isSystemPostType(data) {
  return data?.post_type_category === NEWSBOARD_SYSTEM_TYPE
}

export function isWelcomePostType(data) {
  return data?.post_type?.title === NEWSBOARD_WELCOME_CUSTOM_POST_TYPE
}

export function isPostUnread(post) {
  return !!post?.is_unread
}
